export default function ({ $gtm, route, app }) {
  $gtm.init(process.env.GOOGLE_GTM_ID);

  // track page views on route change
  // if (process.client) {
  //   app.router.afterEach((to) => {
  //     $gtm.push({
  //       event: 'page_view',
  //       page_location: window.location.href,
  //       page_path: to.fullPath,
  //       page_title: document.title,
  //     });

  //   });
  // }
}
